interface WarningBoxProps {
  message: string
  className?: string
  textClass?: string
}

export default function WarningBox(props: WarningBoxProps) {
  const { message, className, textClass } = props

  return (
    <div className={`flex flex-row rounded bg-opacity-30 px-2 ${className ?? `bg-base-content`}`}>
      <img src={`/images/warning-icon.svg`} alt="warning" className="w-6" />
      <p className={`max-w-screen-md px-2 py-4 font-light ${textClass ?? `text-xs`}`}>{message}</p>
    </div>
  )
}
